import axios from "axios";

export const state = {
    examsettings: [],
};

export const getters = {
    examsettings: state => state.examsettings,
};

export const mutations = {
    setExam(state, newValue) {
        state.examsettings = newValue
    },
};

export const actions = {
    fetchExamSettings({ commit }) {
        axios.get('/examsettings').then(res => {
            commit('setExam', res.data.examsettings);
        })
    },
};
